import * as ProfileActions from "../actionTypes/profileDetailsActionTypes";
import { IErrorResponseType } from "../../constants/commonTypes";
import { ProfileDetailsState } from "../reducers/profileDetailsReducer";


export function getProfileDetails(): ProfileActions.GetProfileDetailsAction {
  return {
    type: ProfileActions.GET_PROFILE_DETAILS
  };
}

export function getProfileDetailsRequest(): ProfileActions.GetProfileDetailsRequestAction {
  return {
    type: ProfileActions.GET_PROFILE_DETAILS_REQUEST
  }
}

export function getProfileDetailsSuccess(response: ProfileDetailsState): ProfileActions.GetProfileDetailsSuccessAction {
  return {
    type: ProfileActions.GET_PROFILE_DETAILS_SUCCESS,
    response
  }
}

export function getProfileDetailsFailure(error: Error | string | IErrorResponseType): ProfileActions.GetProfileDetailsFailureAction {
  return {
    type: ProfileActions.GET_PROFILE_DETAILS_FAILURE,
    error
  }
}


export function getAumDetails(): ProfileActions.AumMobileAction {
  return {
    type: ProfileActions.AUM_MOBILE
  }
}

export function getAumDetailsRequest(): ProfileActions.AumMobileRequestAction {
  return {
    type: ProfileActions.AUM_MOBILE_REQUEST
  }
}

export function getAumDetailsSuccess(response: string): ProfileActions.AumMobileSuccessAction {
  return {
    type: ProfileActions.AUM_MOBILE_SUCCESS,
    response
  }
}

export function getAumDetailsFailure(error: Error | string | IErrorResponseType): ProfileActions.AumMobileFailureAction {
  return {
    type: ProfileActions.AUM_MOBILE_FAILURE,
    error
  }
}
